import fetcher, { fetchErrorMessage, HTTPMethods } from "../hooks/fetcher";

export async function bulkProductAction({
  productIds,
  action,
  tags,
  signedType,
  deactivateParent,
  productTypeId,
  characterTagString,
  franchiseTagString,
  characters,
}) {
  const body = { productIds: [...productIds], action };

  if (tags) {
    body.tags = tags;
  }

  if (signedType) {
    body.signedType = signedType;
  }

  if (deactivateParent !== undefined) {
    body.deactivateParent = deactivateParent;
  }

  if (productTypeId !== undefined) {
    body.productTypeId = productTypeId;
  }

  if (characterTagString) {
    body.characterTagString = characterTagString;
  }

  if (franchiseTagString) {
    body.franchiseTagString = franchiseTagString;
  }

  if (characters) {
    body.characters = characters;
  }

  try {
    return await fetcher("/api/product/shopBuilder/bulk", {
      method: HTTPMethods.POST,
      body: JSON.stringify(body),
    });
  } catch (err) {
    throw new Error(fetchErrorMessage(err));
  }
}

export async function setSignersOnProducts({ productIds, signers }) {
  const response = await window.fetch("/api/product/shopBuilder/bulk/signers", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ productIds: [...productIds], signers }),
  });

  const json = await response.json();

  if (!response.ok) {
    throw Object.assign(new Error(json.message ?? "Something went wrong"), {
      problems: json.problems ?? [],
    });
  }

  return json;
}
